module.exports = __webpack_public_path__ + "static/img/liangshi.b1ed9e05.png";